<script>
    import {onMount} from 'svelte';
    import {confirm} from './Components/Confirmation.svelte';
    import FormModal from './Forms/FormModal.svelte';
    import {tables} from './lib/tables';
    import {assessment_type_categories} from './lib/assessment_type_categories';

    import { notifier } from '@beyonk/svelte-notifications';

    import Assessment from "./Models/assessmentModel";
    import Loader from "./Components/Loader.svelte";
    import AssessmentFilter from './AssessmentFilter.svelte';
    import Question from './Components/Question.svelte';
    import QuestionTags from './Components/QuestionTags.svelte';
    import Notes from './Components/Notes.svelte';
    import SuggestedRecommendation from './Components/SuggestedRecommendation.svelte';
    import SortableTable from './Components/SortableTable.svelte';
    import Collapse from './Components/Collapse.svelte';

    import RecommendationModel from './Models/recommendationModel';

    import Notepad from './Components/Notepad.svelte';
    import Popup from './Components/Popup.svelte';

    import {assign, uniq, groupBy} from 'lodash-es';
    import { addFormModal } from './Forms/ModalFormManager.svelte';

    import {addModal} from './Components/ModalManager.svelte';
    import addLibraryItemModal from './Components/Assessment/AddLibraryItemModal.svelte';
    import AddedItems from './Components/Assessment/AddedItems.svelte';

    import {userMap} from './Utilities/Session.svelte';

    import Fa from "svelte-fa";
    import {faComment} from "@fortawesome/free-solid-svg-icons";
    import {faNoteSticky} from "@fortawesome/free-regular-svg-icons";

    export let params;

    let currentControlID = "";

    // filters
    let levelFilter;
    let hiddenControls = {};

    let debounceTimer;

    // handles for scrolling
    let controlDetailElem;
    let controlElems = {};

    // markers for show/hide
    let showComments = {};
    let showEvidence = {};

    let hiddenAssessors = [];

    let questions = [];
    let control_section_items = {};
    let findings_collapsed = {};

    // form popup
    let formData;

    // loader
    let loading = true;

    // assessment_data
    let assessment_model;
    let assessment;

    // library items
    let has_legacy_recommendations_section = false;
    let show_added_items = false;

    // Scratchpad
    let scratchPadVisible = false;


    // Recommendation List
    let recommendationList = RecommendationModel.getStockRecommendationList();
    let recommendationTemplateModal;


    // show finding suggestions
    let show_finding_suggestions = false;
    let hide_recommendations_section = true;

    function get_control_numbers(category) {
        let category_controls = [];
        for (let subcategory of category.subcategories) {
            for (let control of subcategory.controls) {
                category_controls.push(control.control_number);
            }
        }

        return category_controls
    }

    function addRecommendation(category, data, control) {
        return new Promise((resolve, reject) => {

            // determine assessment type
            let assessment_type = assessment.assessment_type_data.assessment_type_category || "Risk Assessment"

            // clone the object so we don't mess up future instances
            let form = assessment_type_categories[assessment_type].forms['recommendation']
            let formFields = JSON.parse(JSON.stringify(form));

            if (assessment_type == "Risk Assessment") {
                // fix references component which doesn't survive the JSON round-trip
                formFields[8].component = form[8].component
            } else if (assessment_type == "Controls Assessment") {
                formFields[1].autoComplete = get_control_numbers(category);
                if (control) {
                    data['controls'] = [control['control_number']]
                }
            }

            formData = {
                fields: formFields,
                title: "Add Recommendation",
                cancelAction: reject,
                saveAction: resolve,
                data
            }
        }).then((data) => {
            assessment_model.addRecommendation(category.id, data).then(() => {
                notifier.success("Recommendation Added");
            }).catch(() => null);
        }).finally(() => {
            formData = undefined;
        })
    }

    function editRecommendation(recommendation, category) {
        // determine assessment type
        let assessment_type = assessment.assessment_type_data.assessment_type_category || "Risk Assessment"

        // clone the object so we don't mess up future instances
        let form = assessment_type_categories[assessment_type].forms['recommendation']
        let formFields = JSON.parse(JSON.stringify(form));


        // fix references component which doesn't survive the JSON round-trip
        if (assessment_type == "Risk Assessment") {
            // fix references component which doesn't survive the JSON round-trip
            formFields[7].component = form[7].component
        } else if (assessment_type == "Controls Assessment") {
            formFields[1].autoComplete = get_control_numbers(category);
        }
        // clone recommendation so that cancelling doesn't still show up
        let clone = JSON.parse(JSON.stringify(recommendation));

        return new Promise((resolve, reject) => {
            formData = {
                fields: formFields,
                title: "Add Recommendation",
                data: clone,
                cancelAction: reject,
                saveAction: resolve
            }
        }).then((data) => {
           assessment_model.updateRecommendation(data);
        }).catch(() => null).finally(() => {
            formData = undefined;
        })
    }

    function deleteRecommendation(recommendation) {
        confirm("Are you sure you want to delete this recommendation?").then(
            () => {
                assessment_model.deleteRecommendation(recommendation)
            }
        ).catch(() => null)
    }

    function addSuggestedFinding(category, recommendation, control) {
        // make a copy of recommendation
        recommendation = JSON.parse(JSON.stringify(recommendation));
        recommendation.template_id = recommendation._id;

        delete recommendation._id;
        delete recommendation.recommendation_id;
        delete recommendation._rev;

        if (control) {
            recommendation.control_id = control.id;
        }

        return addRecommendation(category, recommendation);

        //assessment_model.addRecommendation(category.id, recommendation);
    }


    function addRecommendationFromTemplate(category, control) {
        return new Promise((resolve, reject) => {
            recommendationTemplateModal = {
                cancelAction: reject,
                saveAction: resolve
            }
        }).then((recommendation_id) => {
            RecommendationModel.getStockRecommendation(recommendation_id).then((recommendation) => addSuggestedFinding(category, recommendation, control)).catch(() => null);
        }).catch(() => {
            null
        }).finally(() => {
            recommendationTemplateModal = undefined;
        })
    }

    async function saveRecommendationTemplate(recommendation) {
        try {
            await confirm("Are you sure you want to update this recommendation for all future reports?");
        } catch (e) {
            return;
        }

        // make a copy
        let recommendation_template = JSON.parse(JSON.stringify(recommendation));

        delete recommendation_template._id;
        delete recommendation_template._rev;
        delete recommendation_template.recommendation_id;
        delete recommendation_template.template_id;

        if (recommendation.template_id) {
            try {
                var stock_recommendation = await RecommendationModel.getStockRecommendation(recommendation.template_id)
            } catch (e) {
                notifier.warning("Recommendation Template does not exist")

                delete recommendation.template_id;
                assessment_model.updateRecommendation(recommendation);

                return
            }
            assign(stock_recommendation, recommendation_template);
            await RecommendationModel.saveStockRecommendation(stock_recommendation);
        } else {
            let new_template = await RecommendationModel.createStockRecommendation(recommendation_template);
            recommendation.template_id = new_template.id;
            assessment_model.updateRecommendation(recommendation);
        }

        notifier.success("Template Saved");
    }

    async function saveNewRecommendation(recommendation) {
        // make a copy
        let recommendation_template = JSON.parse(JSON.stringify(recommendation));

        delete recommendation_template._id;
        delete recommendation_template._rev;
        delete recommendation_template.recommendation_id;
        delete recommendation_template.template_id;

        let new_template = await RecommendationModel.createStockRecommendation(recommendation_template);
        recommendation.template_id = new_template.id;
        assessment_model.updateRecommendation(recommendation);

        notifier.success("Template Created");
    }

    function autofill() {
        addFormModal({
            saveButton: "AutoFill",
            fields: [
                {
                    name: "assessors",
                    label: "Assessors",
                    type: "select",
                    choices: {
                        static: Object.keys(assessment.assessor_results)
                    },
                    multiple: true,
                    dflt: Object.keys(assessment.assessor_results)
                },
                {
                    name: "overwrite",
                    label: "Overwrite Existing Answers",
                    type: "checkbox",
                    dflt: false
                }
            ]
        }).then( async (results) => {
            for (let category of questions) {
                for (let subcategory of category.subcategories) {
                    for (let control of subcategory.controls) {
                        // don't overwrite existing answers
                        let current_answer = assessment_model.getResult(control.id, '').value
                        if (results.overwrite || !current_answer) {
                            let assessor_answers = results.assessors.map((assessor) => assessment_model.getAnswer(assessor, control.id, '').value);
                            let uniq_answers = uniq(assessor_answers);

                            if (uniq_answers.length == 1 && uniq_answers[0] != undefined) {
                                // don't reset if it's already the right value
                                if (uniq_answers[0] != current_answer) {
                                    assessment_model.setResult(control.id, '', uniq_answers[0]);
                                }
                            }
                        }

                        // handle domains
                        if ((assessment.domains.mapping[control.id] || []).length) {
                            for (let domain of assessment.domains.mapping[control.id] ) {

                                let current_domain_answer = assessment_model.getResult(control.id, domain).value
                                if (results.overwrite || !current_domain_answer) {
                                    for (let domain of assessment.domains.mapping[control.id]) {
                                        let assessor_answers = results.assessors.map((assessor) => assessment_model.getAnswer(assessor, control.id, domain).value);
                                        let uniq_answers = uniq(assessor_answers)



                                        if (uniq_answers.length == 1 && uniq_answers[0] != undefined) {
                                            if (uniq_answers[0] != current_domain_answer) {
                                                assessment_model.setResult(control.id, domain, uniq_answers[0]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }).catch(() => {});
    }

    onMount(async () => {
        let assessment_details = await Assessment.getAssessmentDetails(params.id);

        assessment_model = new Assessment(assessment_details);

        let unsub = assessment_model.store.subscribe(data => {
            if (!data) return;

            assessment = data;
            questions = assessment.assessment_type_data.categories;

            for (let category of questions) {
                for (let subcategory of category.subcategories) {
                    for (let control of subcategory.controls) {
                        findings_collapsed[control.id] = false;
                    }
                }
            }

            if (!levelFilter) levelFilter = assessment.details.level;
            loading = false

            has_legacy_recommendations_section = false;
            if (!assessment.assessment_type_data.report_sections || assessment.assessment_type_data.report_sections.length == 0) {
                has_legacy_recommendations_section = true;
            } else {
                for (let section of assessment.assessment_type_data.report_sections) {
                    if (section.section_type == "findings") {
                        has_legacy_recommendations_section = true;
                        break;
                    }
                }
            }

            control_section_items = {};
            if (assessment.assessment_type_data.report_sections) {
                for (let section of assessment.assessment_type_data.report_sections.filter(s => s.section_type == "library")) {
                    let section_data = (data.report_data[section.section_name] || []);
                    let items_by_control = groupBy(section_data, 'control_id');

                    for (let key of Object.keys(items_by_control)) {
                        if (!control_section_items[key]) {
                            control_section_items[key] = {};
                        }

                        control_section_items[key][section.section_name] = {
                            section: section,
                            items: items_by_control[key]
                        };
                    }
                }
            }
        })

        return () => {
            unsub();
        }
    });

    function scrollToControl(id) {
        controlElems[id].scrollIntoView();
    }

    function toggleAssessorFilter(assessor) {
        if (hiddenAssessors.indexOf(assessor) == -1) {
            hiddenAssessors = [...hiddenAssessors, assessor]
        } else {
            hiddenAssessors = hiddenAssessors.filter(a => a != assessor);
        }
    }


    function addLibraryItem(control) {
        addModal(addLibraryItemModal, {
            assessment: assessment
        }).then((selection) => {
            let newItem = JSON.parse(JSON.stringify(selection.item));

            newItem.control_id = control.id;

            assessment_model.saveLibraryItem(selection.section, newItem).then(() => {
                notifier.success("Item Added");
            })
        });
    }

</script>

<Loader {loading}>
    <Popup title="Notepad (saved)" width={400} bind:visible={scratchPadVisible} id="scratchpad">
        <!--<textarea style="width: 100%; height: 100%; resize: none; border: none; outline: none;" bind:value="{assessment.scratch_notes[$session.user.email].text}" on:change={saveScratchNotes}></textarea>-->
        <Notepad bind:visible={scratchPadVisible} {assessment} />
    </Popup>
    <button class="button" class:is-hidden={scratchPadVisible} id="scratchpad-button" on:click={() => scratchPadVisible = !scratchPadVisible} title="Show Notepad">
        <Fa icon={faNoteSticky} />
    </button>

    {#if formData}
        <FormModal {...formData}></FormModal>
    {/if}
<div class="columns viewport">
    <div class="column is-3">
        <AssessmentFilter
            {assessment}
            {questions}
            {assessment_model}
            {levelFilter}
            controlScroll = {currentControlID}
            bind:hiddenControls = {hiddenControls}
            on:controlClick={(evt) => scrollToControl(evt.detail.control.id)}
            statusType="results"
        >
            <span slot="filter">
                <div>
                    <h7 class="title is-7">Assessor Results</h7>
                    <div class="tags">
                        {#each Object.keys(assessment.assessor_results) as assessor}
                            <span class="tag pointer" class:is-info={hiddenAssessors.indexOf(assessor) == -1} on:click={toggleAssessorFilter(assessor)}>
                                {$userMap[assessor] || assessor.split('@')[0].replace(".", " ")}
                            </span>
                        {/each}
                    </div>
                </div>
                <div>
                    <h7 class="title is-7">AutoFill</h7>
                    <div class="buttons">
                        <button class="button is-small" on:click={autofill}>Autofill</button>
                    </div>
                </div>
                <div>
                    <h7 class="title is-7">Suggested Findings</h7>
                    <div class="tags">
                        <span class="tag pointer" class:is-info={show_finding_suggestions} on:click={() => show_finding_suggestions = !show_finding_suggestions}>
                            Show Mapped Items
                        </span>
                    </div>
                </div>
                {#if has_legacy_recommendations_section}
                    <div>
                        <h7 class="title is-7">Recommendations</h7>
                        <div class="tags">
                            <span class="tag pointer" class:is-info={!hide_recommendations_section} on:click={() => hide_recommendations_section = !hide_recommendations_section}>
                                Show Recommendations Sections
                            </span>
                        </div>
                    </div>
                {:else}
                    <div>
                        <h7 class="title is-7">Items</h7>
                        <div class="tags">
                            <span class="tag pointer" class:is-info={show_added_items} on:click={() => show_added_items = !show_added_items}>
                                Show Added Items
                            </span>
                        </div>
                    </div>
                {/if}
            </span>
        </AssessmentFilter>
    </div>

    <div class="column" bind:this={controlDetailElem}>
        {#each questions as category (category.id)}
            <div class:is-hidden={hiddenControls[category.id]}>
                <h1 class="title is-2">{category.name}</h1>
                <hr>
                {#if !hide_recommendations_section}
                    <h2 class="title is-3">Recommendations</h2>

                    <SortableTable
                        sortFields={assessment_type_categories[assessment.assessment_type_data.assessment_type_category || "Risk Assessment"].tables['recommendations']}
                        tableData={assessment.recommendations[category.id]}
                        tableClass="NISTTable"
                    >
                        <div slot="rowActions" let:row={recommendation}>
                            <div class="buttons">
                                <div class="button is-primary" on:click={() => editRecommendation(recommendation, category)}>Edit</div>
                                <div class="button is-danger" on:click={() => deleteRecommendation(recommendation)}>Delete</div>
                                <div class="button is-link" on:click={() => saveRecommendationTemplate(recommendation)}>
                                    {#if recommendation.template_id}
                                        Update Template
                                    {:else}
                                        Save as Template
                                    {/if}
                                </div>
                                {#if recommendation.template_id}
                                    <div class="button is-info" on:click={() => saveNewRecommendation(recommendation)}>
                                        Save as New Template
                                    </div>
                                {/if}
                            </div>
                        </div>
                        <div slot="footerActions">
                            <div class="button is-primary" on:click={() => addRecommendationFromTemplate(category)}>Add From Template</div>
                            <div class="button is-pulled-right" on:click={() => addRecommendation(category)}>Add Recommendation</div>
                        </div>
                    </SortableTable>
                {/if}
            </div>
            {#each category.subcategories as subcategory (subcategory.id)}
                <h3 class="title is-3">
                    {subcategory.control_number} {subcategory.name}
                </h3>

                <div class="columns header">
                    <div class="column">
                        Control
                    </div>
                    <div class="column is-narrow">
                        <div class="results">
                            <div class="final">
                                Final Result
                            </div>
                            {#each Object.keys(assessment.assessor_results) as assessor}
                                {#if !hiddenAssessors.includes(assessor) }
                                    <div class="result">
                                        {$userMap[assessor] || assessor.split('@')[0].replace(".", " ")}
                                    </div>
                                {/if}
                            {/each}
                        </div>
                    </div>
                </div>

                {#each subcategory.controls as control (control.id)}

                <div
                class="control"
                bind:this={controlElems[control.id]}
                class:is-hidden={hiddenControls[control.id]}
                data-controlID={control.id}
                on:focus={() => currentControlID = control.id}
                on:mouseover={() => currentControlID = control.id}
                >
                        <div class="columns">
                            <dv class="column">
                                <div>
                                    <strong>{control.control_number}</strong>
                                    <span class="control-text">
                                        {control.text}
                                    </span>
                                </div>
                                <div class="question-tags buttons are-small">
                                    <QuestionTags {assessment} {control} />
                                </div>
                                <div class="buttons">
                                    {#if has_legacy_recommendations_section}
                                        <div class="button" on:click={() => addRecommendation(category, {}, control)}>Add Recommendation</div>
                                        <div class="button" on:click={() => addRecommendationFromTemplate(category, control)}>Add From Template</div>
                                    {:else}
                                        <div class="button" on:click={() => addLibraryItem(control)}>Add Item</div>
                                    {/if}
                                </div>
                            </dv>
                            <div class="column is-narrow">
                                <span>
                                    <!-- Comments Badge -->
                                    <label class="pointer badge">
                                        <Fa icon={faComment} />
                                        {#if (assessment.control_notes[control.id] || []).length}
                                            <span>{(assessment.control_notes[control.id] || []).length}</span>
                                        {/if}
                                        <input type="checkbox" class="is-hidden" bind:checked={showComments[control.id]}>
                                    </label>

                                    <!-- Evidence Badge -->
                                    {#if (assessment.evidence[control.id] || []).length}
                                    <label class="pointer badge">
                                        &#128193;
                                        <span>{assessment.evidence[control.id].length}</span>
                                        <input type="checkbox" class="is-hidden" bind:checked={showEvidence[control.id]}>
                                    </label>
                                    {/if}
                                </span>
                            </div>
                            <div class="column is-narrow">
                                <div class="results">
                                    <div class="final">
                                        <Question control={control} model={assessment_model} assessment={assessment} />
                                    </div>
                                    {#each Object.keys(assessment.assessor_results) as assessor}
                                        {#if !hiddenAssessors.includes(assessor) }
                                            <div class="result">
                                                {#if assessment_model.getAnswer(assessor, control.id, '', "practice_status", assessment).value}
                                                    <Question control={control} model={assessment_model} assessment={assessment} assessor={assessor} ro="true" />
                                                {:else}
                                                    <div class="button ro is-light">No Answer</div>
                                                {/if}
                                            </div>
                                        {/if}
                                    {/each}
                                </div>
                                <!-- Scope Domains -->
                                {#if (assessment.domains.mapping[control.id] || []).length }
                                    {#each assessment.domains.mapping[control.id] as domain}
                                        <div class="domain">
                                            <h4 class="title is-5">
                                                {domain}
                                            </h4>
                                            <div class="results">
                                                <div class="final">
                                                    <Question control={control} model={assessment_model} assessment={assessment} domain={domain} />
                                                </div>
                                                <!-- Assessor Scope Result -->
                                                {#each Object.keys(assessment.assessor_results) as assessor}
                                                    {#if !hiddenAssessors.includes(assessor) }
                                                        <div class="result">
                                                            {#if assessment_model.getAnswer(assessor, control.id, domain, "practice_status", assessment).value}
                                                                <Question control={control} model={assessment_model} assessment={assessment} assessor={assessor} ro="true" domain={domain} />
                                                            {:else}
                                                                <div class="button ro is-light">No Answer</div>
                                                            {/if}
                                                        </div>
                                                    {/if}
                                                {/each}
                                            </div>
                                        </div>
                                    {/each}
                                {/if}

                            </div>
                        </div>

                            {#if show_added_items}
                                {#if control_section_items[control.id]}
                                    <div class="title is-4">Added Items</div>
                                    {#each Object.keys(control_section_items[control.id]) as section}
                                        {@const section_details = control_section_items[control.id][section] }
                                        <div>
                                            <Collapse title="{section}" title_level=5>
                                                <AddedItems section={section_details.section} added_items={section_details.items} {assessment_model} />
                                            </Collapse>
                                        </div>
                                    {/each}
                                {/if}
                            {/if}

                            {#if show_finding_suggestions}
                                <Collapse title="Mapped Items" title_level=4 bind:collapsed={findings_collapsed[control.id]}>
                                    <SuggestedRecommendation {assessment_model} {control} {assessment} {category} {has_legacy_recommendations_section} on:addFinding={(evt) => addSuggestedFinding(category, evt.detail.recommendation, control)} />
                                </Collapse>
                            {/if}



                         <!-- Comment Display-->
                         {#if showComments[control.id]}
                         <div>
                            <Notes {control} {assessment} />
                         </div>
                         {/if}

                        <!-- Evidence Display -->
                        {#if showEvidence[control.id]}
                            <div>
                                <h3 class="title is-5">Evidence</h3>
                                {#if assessment.evidence[control.id]}
                                    <ul>
                                        {#each assessment.evidence[control.id] as attachment}
                                            <li>
                                                {#if attachment.filename}
                                                <p class="title is-6">
                                                    <span class="link" on:click="{assessment_model.downloadEvidence(attachment)}">
                                                        {attachment.filename || "No File Attached"}
                                                    </span>
                                                </p>
                                                {/if}
                                                <p>{attachment.description}</p>
                                            </li>
                                        {/each}
                                    </ul>
                                {/if}
                            </div>
                        {/if}
                    </div>
                {/each}
            {/each}
        {/each}
    </div>

</div>
</Loader>


{#if recommendationTemplateModal}
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card is-fullwidth">
            <header class="modal-card-head">
            <p class="modal-card-title">Create from Template</p>
                <button class="delete" aria-label="close" on:click={recommendationTemplateModal.cancelAction}></button>
            </header>
            <section class="modal-card-body">
                <SortableTable sortFields={tables["recommendations"]} tableData={$recommendationList} tableClass="NISTTable">
                    <div slot="rowActions" let:row={recommendation}>
                        <div class="button is-success" on:click={() => recommendationTemplateModal.saveAction(recommendation._id)}>Select Control</div>
                    </div>
                </SortableTable>
            </section>
            <footer class="modal-card-foot has-text-right">
                <button class="button is-pulled-right" on:click={recommendationTemplateModal.cancelAction}>Close</button>
            </footer>
        </div>
    </div>
{/if}

<style>
    .column {
        overflow: auto;
        padding: 10px;
    }

    .header {
        font-weight: bold;
        border-bottom: 1px solid #ccc;

    }

    .final {
        width: 250px;
    }

    .results {
        display: flex;
        flex-direction: row;
    }

    .result {
        width: 150px;
    }

    .button.ro {
        cursor: unset;
    }

    .control {
        font-size: 12pt;
        border-bottom: 1px solid #ccc;
        margin-bottom: 15px;
        padding-bottom: 10px;
    }

    .control:hover {
        background-color: #fafaff;
    }

    .domain {
        border-top: 1px solid #ccc;
        margin-top: 10px;
    }

    .question-tags {
        margin-top: 1em;
    }

    .control-text {
        white-space: pre-wrap;
    }

    #scratchpad-button {
        position: fixed;
        top: 50px;
        right: 50px;
        border-radius: 500px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        padding: 0;
        margin: 0;
        cursor: pointer;
    }

    .columns {
        margin-bottom: 0;
    }
</style>